import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "src/app/features/http-services/api.service";
import { UserService } from "src/app/features/shared/user/services/user.service";
import { API_CONSTANTS } from "src/app/features/shared/constants/API-CONSTANTS";
import { StorageService } from "src/app/features/http-services/storage.service";

@Component({
  selector: 'xchange-product-features',
  templateUrl: './product-features.component.html',
  styleUrl: './product-features.component.scss'
})
export class ProductFeaturesComponent {
  @Input("list") list: Array<any> = [];

  constructor(
    private router: Router,
    private apiService: ApiService,
    private userService: UserService,
    public storageService: StorageService,
  ) {}
  ngOnDestroy(): void {
    
  }

  ngOnInit(): void {
    this.list.map((item: any) => {
      if (item.hasOwnProperty("isShow") === false) {
        item.isShow = true;
      }
    });

    this.getClaimsApprovalCount();
  }

  navigation(item: any, subNav:any) {
    if(item?.subNav && item.link == ""){
      if(subNav.name == "Check Available"){
        localStorage.setItem("inventoryFlow", "true");
        localStorage.setItem("order-type", "");
        this.router.navigate([subNav?.link]);
      } else if(item.name == 'Orders'){
        localStorage.removeItem("inventoryFlow");
        this.navigateToOrders(subNav?.key, subNav);
      }else{
        if (item?.queryParams) {
          this.router.navigate([subNav?.link], {
            queryParams: subNav?.queryParams,
          });
        } else {
          this.router.navigate([subNav?.link]);
        }
      }
    }else{
      if (item?.queryParams) {
        this.router.navigate([item?.link], {
          queryParams: item?.queryParams,
        });
      } else {
        this.router.navigate([item?.link]);
      }
    }
  }

  navigateToOrders(name:any, item:any){
    localStorage.removeItem("inventoryFlow");
    if(name == 'new-order' || name == 'order-sample'){
      let orderType = (name == 'new-order' ? "orderStandard" : "orderSample"); 
      localStorage.setItem("order-type", orderType);
      if (
        this.storageService.cartData == undefined ||
        this.storageService.cartData == "" ||
        this.storageService.cartData.hasOwnProperty("errorMessage") ||
        this.storageService.cartData?.totalItems == 0
      ) {
        this.router.navigate([item?.link]);
      }else{
        this.router.navigate([`residential/products/${name}`]);
      }
      
    }else if(name == 'order-history'){
      this.router.navigate([item?.link], {
        queryParams: { page: 0 },
      });
    }
  }

  claimsApprovalCount:any = 0;
  getClaimsApprovalCount(){
    this.userService.getClaimApprovalCount().subscribe(
        (res: any) => {
          this.claimsApprovalCount = res?.body || 0;
        },
        (err: any) => {}
      );
  }

  navigateToclaims(name:any, item:any){
    this.router.navigate([`residential/claims/${name}`]);
  }
}
